"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectListItem = exports.SELECT_LIST_ITEM_CLASS = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _ui = require("../../ui");
require("../../../src/ui/selectListItem/selectListItem.module.scss");
var _tooltip = require("../tooltip/tooltip");
var _excluded = ["children", "className", "icon", "iconSize", "iconStyle", "list", "listLabel"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
var SELECT_LIST_ITEM_CLASS = 'kui-select-list-item';

// accessibility ok
exports.SELECT_LIST_ITEM_CLASS = SELECT_LIST_ITEM_CLASS;
var SelectListItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    icon = props.icon,
    iconSize = props.iconSize,
    _props$iconStyle = props.iconStyle,
    iconStyle = _props$iconStyle === void 0 ? {} : _props$iconStyle,
    list = props.list,
    listLabel = props.listLabel,
    attributes = _objectWithoutProperties(props, _excluded),
    childrenEl = null,
    iconEl = null,
    listEl = null;
  className = (0, _utils.ClassNames)(SELECT_LIST_ITEM_CLASS, list ? SELECT_LIST_ITEM_CLASS + '--with-list' : null, SELECT_LIST_ITEM_CLASS + '--icon-size_' + iconSize, className);
  if (icon) {
    iconEl = /*#__PURE__*/React.createElement(_ui.Icon, {
      className: "kui-select-list-item__icon",
      size: iconSize,
      xlink: icon,
      style: iconStyle
    });
  }
  if (children) {
    var childrenArray =
    // children could be string, we need array
    Array.isArray(children) ? children : [children];
    childrenEl = React.Children.map(childrenArray, function (child) {
      if (!child.type || !child.type.displayName || child.type.displayName !== 'Userpic') return child;
      iconEl = /*#__PURE__*/React.cloneElement(child, {
        className: (0, _utils.ClassNames)('kui-select-list-item__icon', child.props.className)
      });
    });
  }
  if (list) {
    listEl = /*#__PURE__*/React.createElement("span", {
      className: "kui-select-list-item__col kui-select-list-item__col--list"
    }, /*#__PURE__*/React.createElement(_tooltip.Tooltip, {
      direction: 'left',
      value: listLabel
    }, /*#__PURE__*/React.createElement("span", {
      className: "kui-select-list-item__list",
      "aria-hidden": true // лишняя инфа для скринридера
    }, list)), /*#__PURE__*/React.createElement("span", {
      "aria-label": listLabel // если есть listLabel, отдать его скринридеру
    }));
  }
  return /*#__PURE__*/React.createElement("li", _extends({
    className: className,
    ref: ref
  }, attributes), /*#__PURE__*/React.createElement("span", {
    className: "kui-select-list-item__col kui-select-list-item__col--icon"
  }, iconEl), /*#__PURE__*/React.createElement("span", {
    className: "kui-select-list-item__col kui-select-list-item__col--title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "kui-select-list-item__title"
  }, childrenEl)), listEl);
});
exports.SelectListItem = SelectListItem;
SelectListItem.defaultProps = {
  icon: null,
  iconSize: 16,
  list: null,
  listLabel: null
};
SelectListItem.displayName = 'SelectListItem';